/**
 * This component contains code to delete a software, this is just a confirmation modal.
 */
import {
  DialogContent,
  IconButton,
  Typography,
  Button,
  DialogActions,
  CardHeader
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Close from "@mui/icons-material/Close";
import DashedDivider from "common/ui/DashedDivider";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";
import { useQueryClient } from "@tanstack/react-query";
import { useDeleteSoftware } from "services/softwares.service";
import LoadingButton from "common/ui/LoadingButton";
import { setDeleteSoftware } from "context/modal.context";
import { useAppDispatch, useAppSelector } from "context/hooks";
import { selectDeleteSoftware } from "context/modal.selector";
import { toast } from "react-hot-toast";

function DeleteModal() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch();

  const props = useAppSelector(selectDeleteSoftware);
  const handleDeleteSoftware = (softwareId) => {
    deleteSoftware.mutate({ softwareId });
  };

  function onSoftwareDeleted(_data, error) {
    queryClient.invalidateQueries({ queryKey: ["software", "list"] });

    let message = t("deleteModal.deleted");

    if (!error) {
      toast.success(message);
    }

    dismiss();
  }

  function dismiss() {
    dispatch(
      setDeleteSoftware({
        open: false
      })
    );
  }
  const deleteSoftware = useDeleteSoftware(onSoftwareDeleted);

  return (
    <Dialog open={props.open} scroll="body" maxWidth="sm" fullWidth>
      <DialogTitle
        component={CardHeader}
        avatar={<DeleteIcon />}
        title={t("deleteModal.deleteSoftware")}
        titleTypographyProps={{ variant: "h6" }}
        action={
          <IconButton onClick={dismiss}>
            <Close />
          </IconButton>
        }
        sx={{ color: "gray.main" }}
      />
      <DashedDivider style={{ width: "96%", margin: "auto" }} />
      <DialogContent sx={{ textAlign: "center" }}>
        <Typography>{t("deleteModal.confirmDelete")}</Typography>
      </DialogContent>
      <DashedDivider style={{ width: "96%" }} />
      <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          onClick={dismiss}
          variant="outlined"
          size="large"
          color="primary"
        >
          {t("common.cancel")}
        </Button>
        <LoadingButton
          loading={deleteSoftware.isLoading}
          onClick={() => handleDeleteSoftware(props.softwareId)}
          variant="outlined"
          size="large"
          color="error"
        >
          {t("deleteModal.delete")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteModal;
